package com.milta.feature.admin.domain.usecase

import com.milta.feature.admin.domain.entity.AdminAccounts
import com.milta.feature.admin.domain.repository.AdminRepository

class GetAdminAccountsUseCase(private val repository: AdminRepository) {
    suspend operator fun invoke(): Result<AdminAccounts> = repository.getAccounts()
}
